var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"dl-reports"}},[_c('router-view',{attrs:{"dateRange":_vm.dateRange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }